const VoucherStatus = {
  Unclaimed: "unclaimed",
  Used: "used",
  Expired: "expired",
  Available: "available-in-app",
  Void: "void",
  AvailableInApp: "available-in-app",
  Assigned: "assigned",
};

export default VoucherStatus;
